/* ==========================================================================
   CL · Vitrina SEO — parallax del fondo con GSAP ScrollTrigger
   El fondo (productos flotantes) se desplaza en Y conforme la sección
   cruza el viewport. Degradación elegante: si GSAP/ScrollTrigger no están
   disponibles o el usuario prefiere menos movimiento, no se hace nada
   (la sección se ve estática, sin romperse).
   ========================================================================== */

(function () {
	'use strict';

	function reduceMotion() {
		return (
			window.matchMedia &&
			window.matchMedia('(prefers-reduced-motion: reduce)').matches
		);
	}

	function initSection(section) {
		if (section.dataset.clseoInit === 'true') return;
		var bg = section.querySelector('[data-clseo-bg]');
		if (!bg) return;

		section.dataset.clseoInit = 'true';

		if (reduceMotion()) return; // sin movimiento por preferencia del usuario

		gsap.registerPlugin(ScrollTrigger);
		section.classList.add('clseo--parallax');

		var intensity = parseFloat(section.dataset.clseoIntensity);
		if (isNaN(intensity)) intensity = 20;
		intensity = Math.max(0, Math.min(100, intensity));

		/* Solo se MUEVE la imagen (no se reescala). El desplazamiento es
		   proporcional a la intensidad (yPercent del alto de la imagen a cada
		   lado). El margen para que no se vea hueco lo da el alto de la imagen
		   que suba el merchant: una imagen más grande = más margen. */
		var shift = intensity * 0.25;
		var imgs = section.querySelectorAll('.clseo__bg-img');

		gsap.fromTo(
			imgs,
			{ yPercent: shift },
			{
				yPercent: -shift,
				ease: 'none',
				scrollTrigger: {
					trigger: section,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true
				}
			}
		);
	}

	function initAll() {
		if (!window.gsap || !window.ScrollTrigger) return false;
		document.querySelectorAll('.clseo').forEach(initSection);
		return true;
	}

	/* GSAP se carga con defer desde el CDN; normalmente ya está listo cuando
	   corre este script (también deferido y en orden). Igual reintentamos por
	   si el CDN tarda, y nos rendimos tras ~4s (queda sin parallax, no roto). */
	function boot() {
		if (initAll()) return;
		var tries = 0;
		var timer = window.setInterval(function () {
			tries += 1;
			if (initAll() || tries > 40) window.clearInterval(timer);
		}, 100);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}

	/* Recalcular posiciones cuando cargue todo (imágenes de fondo) */
	window.addEventListener('load', function () {
		if (window.ScrollTrigger) window.ScrollTrigger.refresh();
	});

	/* Editor de temas: re-inicializar al recargar la sección */
	document.addEventListener('shopify:section:load', function () {
		initAll();
		if (window.ScrollTrigger) window.ScrollTrigger.refresh();
	});
})();
